/*
 * @Author: chengyu
 * @Date: 2022-09-26 19:06:37
 * @Description: 支付宝小程序适配器
 * 支付宝小程序开发文档：https://opendocs.alipay.com/mini/api/owycmh
 */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { getContext } from '../../../config';
import { mapError, mapLog } from '../../../utils/logger';
import { convertHeaders } from '../../../utils/transform';
import { getTrackParams, getTrackResponse, trackHttp, } from '../../../utils/ubt';
var statusList = {
    11: '无权跨域',
    12: '网络出错',
    13: '超时',
    14: '解码失败',
    19: 'HTTP错误',
};
function adapter(request, responseCallback) {
    var baseParams = {
        method: request.method,
        url: request.url,
        dataType: 'text',
        headers: request.headers,
        data: request.body,
        timeout: request.timeout,
        responseType: request.responseType,
    };
    var trackParams = getTrackParams(baseParams);
    var params = __assign(__assign({}, baseParams), { success: function (res) {
            responseCallback({
                statusCode: res.status,
                responseText: res.data,
                headers: convertHeaders(res.headers),
            });
            trackParams.success(getTrackResponse(res));
            mapLog('alipay adapter success', [res]);
        }, fail: function (res) {
            responseCallback({
                statusCode: res.status || 0,
                statusMessage: res.errorMessage,
            });
            trackParams.fail(res);
            mapError('alipay adapter fail', res);
        } });
    var context = getContext();
    if (typeof context.request === 'function') {
        /**
         * 原生小程序 网络监控
         * https://hellobike.yuque.com/docs/share/af513f21-d947-4246-9738-9c8cf21e6256?#
         */
        trackHttp(trackParams);
        context.request(params);
    }
    else {
        var _params = __assign(__assign({}, params), { method: request.method, url: request.url, dataType: 'text', headers: request.headers, data: request.body || {}, timeout: request.timeout || 20000, success: function (res) {
                responseCallback({
                    statusCode: res.status,
                    responseText: res.data,
                    headers: convertHeaders(res.headers),
                });
                trackParams.success(getTrackResponse(res));
                mapLog('alipay adapter success', [res]);
            }, fail: function (res) {
                responseCallback({
                    statusCode: res.status || 0,
                    statusMessage: res.errorMessage,
                    responseText: res.data,
                    headers: convertHeaders(res.headers),
                    errMsg: statusList[res.status || 0] || '',
                });
                trackParams.fail(res);
                mapError('alipay adapter fail', res);
            } });
        trackHttp(trackParams);
        // my.httpRequest
        // https://opendocs.alipay.com/support/01rb31#my.request%20%E4%B8%8E%20my.httpRequest%20%E7%9A%84%E5%8C%BA%E5%88%AB%E6%98%AF%E4%BB%80%E4%B9%88%EF%BC%9F
        context.httpRequest(_params);
    }
}
export default adapter;
//# sourceMappingURL=data:application/json;base64,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